module.exports = parcelRequire.resolve("57pY2");